import FirmwareUpgradeOptions from "./FirmwareUpgradeOptions.js";
import FirmwareReleaseId from "./FirmwareReleaseId.js";
import ImagineGroupId from "./ImagineGroupId.js";
import DeviceType from "./DeviceType.js";
import DeviceTypeId from "./DeviceTypeId.js";
import ProjectId from "./ProjectId.js";
import Metadata from "./Metadata.js";
import Id from "./Id.js";
import ImagineGroupName from "./ImagineGroupName.js";
import FirmwareRelease from "./FirmwareRelease.js";
import Name from "./Name.js";
import Concurrency from "./Concurrency.js";
import MaxRetries from "./MaxRetries.js";
import PercentDevicesToUpgrade from "./PercentDevicesToUpgrade.js";
import UseOperationHours from "./UseOperationHours.js";
import UseTypeUpgradePaths from "./UseTypeUpgradePaths.js";
function install(molten) {
  molten.addPlugin('Attribute', Id);
  molten.addPlugin('Attribute', ImagineGroupId);
  molten.addPlugin('Attribute', ImagineGroupName);
  molten.addPlugin('Attribute', ProjectId);
  molten.addPlugin('Attribute', DeviceTypeId);
  molten.addPlugin('Attribute', DeviceType);
  molten.addPlugin('Attribute', FirmwareReleaseId);
  molten.addPlugin('Attribute', FirmwareRelease);
  molten.addPlugin('Attribute', FirmwareUpgradeOptions);
  molten.addPlugin('Attribute', Metadata);
  molten.addPlugin('Attribute', Name);
  molten.addPlugin('Attribute', Concurrency);
  molten.addPlugin('Attribute', MaxRetries);
  molten.addPlugin('Attribute', PercentDevicesToUpgrade);
  molten.addPlugin('Attribute', UseOperationHours);
  molten.addPlugin('Attribute', UseTypeUpgradePaths);
}
export default {
  install
};